// extracted by mini-css-extract-plugin
export default {"container":"container_container__XRHHk","shrink":"container_shrink__pzKg9"};